<!-- <button *ngFor="let d of dichiarazioni" class="btn btn-link" (click)="onDownloadDichiarazione(d.Id)">
{{d.Descrizione}}
</button> -->


<div ngbDropdown class="d-inline-block">
  <button class="btn btn-outline-success btn-sm" ngbDropdownToggle>Scarica dichiarazione</button>
  <div ngbDropdownMenu>
    @for (d of dichiarazioni; track d) {
      <button ngbDropdownItem class="btn btn-link"
        (click)="onDownloadDichiarazione(d.Id)">
        {{d.Descrizione}}
      </button>
    }
  </div>
</div>
